// extracted by mini-css-extract-plugin
export default {"band":"styles_band__7F3Gy","band--orange":"styles_band--orange__67VWl","band--yellow":"styles_band--yellow__4AsVd"};